import React, { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/auth';
import api from '../../services/api';
import List from '../../components/Crud/List';
import {
  getLastFilterByKey,
  upsertFilterToKey,
} from '../../services/filterService';
import EstimatesFilter, { EstimateFilterFields } from './EstimatesFilter';
import EstimateStatus from '../../enums/EstimateStatus';
import EstimatesList from './EstimatesList';
import { EstimateTag } from '../../models/estimate/EstimateViewModel';

export type EstimateModel = {
  createdAt: string;
  updatedAt: string;
  id: number;
  number: string;
  status: EstimateStatus;
  statusLabel: string;
  companyType: number;
  companyIdentifier: string;
  companyName: string;
  companyAlias: string;
  customerType: number;
  customerIdentifier: string;
  customerName: string;
  customerAlias: string;
  transactionNatureId: number;
  transactionNatureName: string;
  estimateTags: EstimateTag[];
};

export default function EstimatesIndex() {
  const pageKey = 'estimates';
  const [isLoading, setIsLoading] = useState(false);
  const [estimates, setEstimates] = useState([] as EstimateModel[]);
  const [filterFields, setFilterFields] = useState<EstimateFilterFields>(
    null as unknown as EstimateFilterFields
  );

  const {
    user: { organization },
    isAdmin,
  } = useAuth();

  async function getEstimates(data: EstimateFilterFields) {
    if (organization) {
      setIsLoading(true);
      const response = await api.get(
        `organizations/${organization.id}/estimates`,
        {
          params: data,
        }
      );
      setEstimates(response.data.data);
      setIsLoading(false);
    }
  }

  const onFilterSubmit = (data: EstimateFilterFields) => {
    const filter = new EstimateFilterFields(data);
    upsertFilterToKey(pageKey, filter);
    setFilterFields(filter);
    getEstimates(data);
  };

  useEffect(() => {
    const filters = getLastFilterByKey(pageKey, EstimateFilterFields);
    setFilterFields(filters);
    getEstimates(filters);
  }, [organization]);

  return (
    <List
      isLoading={isLoading}
      title='Orçamentos'
      newItemUrl='new'
      withNewAction={isAdmin}
      filter={
        <EstimatesFilter
          filterFields={filterFields}
          onSubmit={onFilterSubmit}
          pageKey='estimates'
        />
      }
    >
      <EstimatesList estimates={estimates} />
    </List>
  );
}
